import PropTypes from 'prop-types';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { BaseCellComp } from '../BaseCellComp';
import { Check } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { Cell } from '../Cell';
import { CellButton, CellButtons } from '../CellButton';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { selectWorks } from '../../../Api/selectors';

import styles from './BVI.module.css';


const Container = styled.div``;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BVIStep2CompleteComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    //this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            {this.props.cell.busy || this.props.work ? (
              <Loader small />
            ) : (
              <div className={styles.cellButtonContainer}>
                <CellButton onClick={this.props.done}>
                  <Check />
                </CellButton>

                {/* <CellButton onClick={() => this.toHelgaVehicle(vehicle.vehicle_helga_id)}>
                  <img height="23" src="/public/helga_icon.svg" />
                </CellButton> */}
              </div>
            )}
          </CellButtons>
        </Container>
      </Cell>
    );
  }
}

BVIStep2CompleteComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.action.id}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    done() {
      dispatch(performAction(ownProps.action.id, ownProps.cell.vehicle.id));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIStep2Complete = compose(
  withConnect,
  withRouter,
)(BVIStep2CompleteComp);
